/** biome-ignore-all lint/correctness/useHookAtTopLevel: TODO: fix */
import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeNonLCCApproversList } from './normalize';

export const fetchNonLCCApproversList = createProvider(api.fetchNonLCCApproversList)
  .andThen((res) => normalizeNonLCCApproversList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
